var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","return-object":"","items":_vm.assetList,"label":"Asset","prepend-inner-icon":"mdi-progress-check"},model:{value:(_vm.asset),callback:function ($$v) {_vm.asset=$$v},expression:"asset"}})
}
var staticRenderFns = []

export { render, staticRenderFns }